import { EXPERT_APPLICATION_STEPS } from "./enums";

export const EXPERT_FOLLOW_UP_CHANNEL_NAME = "CanopyFollowUp";
export const NEW_FEATURE_REQUEST_CHANNEL_NAME = "NewFeaturesRequest";
export const CANOPY_AUDIO_REQUEST_CHANNEL_NAME = "CanopyAudioRequest";

export const MANDATORY_PAST_WORK_HISTORY_MONTHS = 12;

export const PROJECT_STEPS_IN_ORDER: EXPERT_APPLICATION_STEPS[] = [
  EXPERT_APPLICATION_STEPS.ENGAGEMENT_AGREEMENT,
  EXPERT_APPLICATION_STEPS.COMPANY_VALIDATION,
  EXPERT_APPLICATION_STEPS.COMPLIANCE_QUESTIONS,
  EXPERT_APPLICATION_STEPS.VENDOR_SCREENING,
  EXPERT_APPLICATION_STEPS.SCREENING_QUESTIONS,
  EXPERT_APPLICATION_STEPS.AVAILABILITY,
  EXPERT_APPLICATION_STEPS.SOFTWARE_REVIEW,
  EXPERT_APPLICATION_STEPS.APPLICATION_SUBMITTED
];

export const CANOPY_STEPS_IN_ORDER: EXPERT_APPLICATION_STEPS[] = [
  EXPERT_APPLICATION_STEPS.ENGAGEMENT_AGREEMENT,
  EXPERT_APPLICATION_STEPS.COMPLIANCE_QUESTIONS,
  EXPERT_APPLICATION_STEPS.COMPANY_VALIDATION,
  EXPERT_APPLICATION_STEPS.APPLICATION_SUBMITTED
];
